<template>
  <router-view />
</template>

<script>
import { defineComponent } from "vue";
import BASE_URL from "@/services/baseUrl";

export default defineComponent({
  name: "App",
  computed: {
    userOrganization() {
      return this.$store.getters.getUserOrganization;
    },
    userOrganizationName() {
      if (!this.userOrganization) return null;
      return this.userOrganization.name;
    },
    userOrganizationLogo() {
      if (!this.userOrganization) return null;
      return `${BASE_URL}/${this.userOrganization.logo}`;
    },
  },
  watch: {
    userOrganizationName: {
      handler(newVal) {
        if (!newVal) return;
        window.document.title = newVal;
      },
      immediate: true,
    },
    userOrganizationLogo: {
      handler(newVal) {
        if (!newVal) return;
        const link = document.createElement("link");
        link.rel = "icon";
        link.href = newVal;
        document.head.appendChild(link);
      },
      immediate: true,
    },
  },
  mounted() {
    // this.$store.dispatch("getOrganizationUsers");
  },
});
</script>

<style lang="scss">
html,
body {
  @apply h-full w-full m-0 p-0;

  #app {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      Helvetica, Arial, sans-serif;
    @apply h-full w-full;
  }

  .el-form-item--label-top .el-form-item__label {
    @apply text-xs;
  }
}

@media print {
  html,
  body {
    @apply h-auto w-auto m-0 p-0;
  }
}
</style>
<script setup lang="ts"></script>
